import { currencyReducers } from './currency/currency.reducers';
import { lovReducers } from './lov/list-of-value.reducers';
import { userInfoReducers } from './user-info/user-info.reducers';

export const reducers = {
  ...currencyReducers,
  ...userInfoReducers,
  ...lovReducers,
};
